import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<"textarea">>(function Textarea({ className, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      data-slot="textarea"
      // The resting treatment is `input.tsx`'s, exactly: same fill (`bg-input/70`, one value for both
      // themes), same `rounded-lg`, and no `shadow-xs` — a textarea renders directly beside an Input in
      // most forms, and three departures at once made one 3-field form read as a filled soft-cornered
      // field above two outlined boxes with tighter corners and a drop-shadow. Elevation on both comes
      // from the hairline border (flat-X rule 1). Guard: `textarea.spec.tsx` asserts the two AGREE, so
      // re-tuning the recipe has to move both.
      className={cn(
        "flex field-sizing-content min-h-16 w-full rounded-lg border border-control-boundary bg-input/70 px-3 py-2 text-base transition-[color,box-shadow] outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 md:text-sm dark:aria-invalid:ring-destructive/40",
        className
      )}
      {...props}
    />
  )
})

Textarea.displayName = "Textarea"

export { Textarea }
